<template>	   
	<v-container>
	 	<v-card>
	 	 	<v-card-title primary-title>
	 	 		<h3 class="display-1">Resultados</h3>
	 	 	</v-card-title>
	 	 	<v-card-text>
	 	 		<v-tabs
			    centered
			    color="indigo"
			    icons-and-text
			  >
			    <v-tabs-slider color="green"></v-tabs-slider>
			    <v-tab href="#tab-1" v-if="false">
			      Mapa
			      <v-icon>fas fa-map</v-icon>
			    </v-tab>

			    <v-tab href="#tab-2">
			      Graficos
			      <v-icon>fas fa-chart-pie</v-icon>
			    </v-tab> 

			    <v-tab href="#tab-3" v-if="false">
			      Evolución
			      <v-icon>fas fa-table</v-icon>
			    </v-tab>
			    <v-tab href="#tab-4" v-if="false">
			      Informes
			      <v-icon>fas fa-download</v-icon>
			    </v-tab>
				  <v-tab-item :value="'tab-1'">
				    <Maps />
				  </v-tab-item>
				  <v-tab-item :value="'tab-2'">
				    <Graphics />
				  </v-tab-item>
				  <v-tab-item :value="'tab-3'">
				   	<Evolution />
				  </v-tab-item>
				  <v-tab-item :value="'tab-4'">
				   	<Report />
				  </v-tab-item>
			  </v-tabs>
	 	 	</v-card-text>
	 	 	<v-card-actions>

	 	 	 
	 	 	</v-card-actions>
	 	</v-card>
	 	<v-snackbar
	 	  v-model="alert.active"
	 	>
	 	 {{ alert.messague }}
	 	  <v-btn text :color="alert.color" @click.native="alert.active = false">Close</v-btn>
	 	</v-snackbar>
	</v-container>
</template>
<script>
import Maps from './Maps.vue';
import Graphics from './Graphics.vue';
import Report from './Report.vue';
import Evolution from './Evolution.vue';

	export default{
		components: {
			Maps, Graphics, Evolution, Report
		},
		created() {
			
		},
		mounted(){
			
		},
		props: [
			'auth'
		],
		data(){
			return {
				baseRoute: 'http://gis.localdev.com.ar/api/gis',
				alert: {
					active: false,
					messague: '',
					color: ''
				},
				filters: {
					dataset: {},
					boolsubp: false,
				},
				datasets: [],
			}
		},
		methods: {
			

		},
		watch: {

		},
		computed: {

		},
	}
</script>